







import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"

@Component
export default class ChooseColor extends AbpBase {
	/**
	 * 接收遍历的颜色
	 * */
	@Prop({type:Array}) colors: any
	html = '&#xe66f;'
	selected = 0
	selectOne(index: number){
		this.selected = index
		this.$emit("pick", index)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chooseColor.vue